import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Provider as UhP } from 'use-http';
import { LoadingSpinner, useAuth0 } from '@ondeck/silkworm';
import ApplicationPage from 'pages/ApplicationPage';
import LoginPage from 'pages/LoginPage';
import ProtectedRoute from 'components/ProtectedRoute';
import ErrorPage from 'pages/ErrorPage';
import ForgotPasswordPage from 'pages/ForgotPasswordPage';

const PageRouter = () => {
  const { isInitializing, isAuthenticated, getTokenSilently } = useAuth0();

  const options = {
    interceptors: {
      request: async ({ options }: any) => {
        options.headers = {
          ...options.headers,
          'Content-Type': 'application/json',
          Accept: 'application/json'
        };

        if (isAuthenticated) {
          options.headers.Authorization = `Bearer ${await getTokenSilently()}`;
        }
        return options;
      }
    }
  };

  const PartnerDealPage = () => {
    window.location.href =
      window.env.REACT_APP_PARTNER_PORTAL + '/resources/#/deals/submitted';
    return null;
  };

  return isInitializing ? (
    <LoadingSpinner>
      <FormattedMessage id="common.loading.message" />
    </LoadingSpinner>
  ) : (
    <UhP options={options}>
      <Switch>
        <Route
          exact
          path={'/login'}
          component={isAuthenticated ? PartnerDealPage : LoginPage}
        />
        <Redirect exact from={'/'} to={`${sessionStorage.getItem('url')}`} />
        <ProtectedRoute
          exact
          path="/application/:businessId"
          component={ApplicationPage}
        />
        <Route exact path={'/forgot-password'} component={ForgotPasswordPage} />
        <Route path={'*'} component={ErrorPage} />
      </Switch>
      <ProtectedRoute exact path={'/'} component={ErrorPage} />
    </UhP>
  );
};

export default PageRouter;
